const Status = {
  EMAIL_VERIFICATION: "EMAIL_VERIFICATION",
  GST: "GST",
  PAYMENT: "PAYMENT",
  TNC: "TNC",
  BANK_DETAILS: "BANK_DETAILS",
};

export default Status;
